import * as React from "react";
import {db} from "../../firebase";
import {withAuthorization} from "../../firebase/withAuthorization";
import {CategoryList} from "../../pills/categories/categoriesList";
import {CategoryAddForm} from "../../pills/categories/categoryAddForm";
import {Button, Header, Modal} from 'semantic-ui-react'


class CategoriesComponent extends React.Component {
    constructor(props: any) {
        super(props);
        this.state = {
            categories: null,
            tags: null,
            modalOpen: false
        };

        this.handleAddCategory = this.handleAddCategory.bind(this)
        this.handleModalClose = this.handleModalClose.bind(this)
    }

    public componentDidMount() {
        db.onceGetCategories().then(snapshot => {
            let feed = [];
            snapshot.forEach((categorySnap) => {
                const category = categorySnap.val()
                feed.push(category);
            })
            this.setState(() => ({
                categories: feed.sort((a, b) => {
                    return parseInt(a.priority) - parseInt(b.priority)
                })
            }))
        });

        db.onceGetTags().then(snapshot =>
            this.setState(() => ({tags: snapshot.val()}))
        );
    }

    public handleAddCategory() {
        db.onceGetCategories().then(snapshot => {
            var feed = [];
            snapshot.forEach((categorySnap) => {
                const category = categorySnap.val()
                feed.push(category);
            })
            this.setState(() => ({
                categories: feed.sort((a, b) => {
                    return parseInt(a.priority) - parseInt(b.priority)
                }),
                modalOpen: false
            }))
        });
    }

    handleOpen = () => this.setState({modalOpen: true})

    handleModalClose = () => this.setState({modalOpen: false})


    public render() {
        const {categories, tags, modalOpen}: any = this.state;
        return (
            <div>
                <Header as='h2'>List of Categories
                    <Modal
                        open={modalOpen}
                        trigger={
                            <Button size='tiny' onClick={this.handleOpen} style={{marginLeft: '20px'}} positive>Add
                                Category</Button>
                        }>
                        <Modal.Header>Add a category</Modal.Header>
                        <Modal.Content>
                            <CategoryAddForm onModalClosed={this.handleModalClose} tags={tags}
                                             onCategoryAdded={this.handleAddCategory}/>
                        </Modal.Content>
                    </Modal>
                </Header>
                {!!categories && <CategoryList categories={categories}/>}
            </div>
        )
    }
}

const authCondition = (authUser: any) => !!authUser;

export const CategoriesPage = withAuthorization(authCondition)(CategoriesComponent);



// WEBPACK FOOTER //
// ./src/pages/Categories/index.tsx